import Service from '@ember/service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import TabData from '../data/tabdata';
import Constants from '../utils/constants';
import Utils from '../utils/utils';
import cloneDeep from 'lodash.clonedeep';

export default class TabService extends Service {
  @service validationService;

  @tracked selected = null;
  numberOfTabs = null;

  constructor() {
    super(...arguments);

    const tabKeys = Object.keys(TabData.tabs),
      defaultKey = tabKeys.find((key) => TabData.tabs[key].default);

    this.selected = this.getTabByKey(defaultKey);
    this.numberOfTabs = tabKeys.length;
  }

  get tabs() {
    return Object.keys(TabData.tabs)
      .map((key) => this.getTabByKey(key))
      .sort(this.sortTabs);
  }

  get nextTab() {
    return this.getTab(Constants.TAB.NEXT);
  }

  get previousTab() {
    return this.getTab(Constants.TAB.PREVIOUS);
  }

  goToTab(tab) {
    this.selected = tab;
  }

  getTabByKey(key) {
    const tab = cloneDeep(TabData.tabs[key]);
    let result = {};

    result.name = tab.name;
    result.index = tab.index;

    result.isSelected = this.selected && this.selected.name === tab.name;

    if (tab.disableIfNoSelectedDac) {
      result.isDisabled = (selectedDac) => {
        return selectedDac ? false : true;
      };
    } else {
      result.isDisabled = () => {
        return false;
      };
    }

    Utils.generateNamingMetadata(result);
    return result;
  }

  getTabByIndex(index) {
    const tabKeys = Object.keys(TabData.tabs),
      indexKey = tabKeys.find((key) => TabData.tabs[key].index == index);

    if (indexKey) return this.getTabByKey(indexKey);
    else return null;
  }

  getTab(value) {
    const currentIndex = this.selected.index;
    if (value === Constants.TAB.NEXT) {
      return this.getTabByIndex(currentIndex + 1);
    } else if (value === Constants.TAB.PREVIOUS) {
      return this.getTabByIndex(currentIndex - 1);
    } else {
      return null;
    }
  }

  setTab(value) {
    const newTab = this.getTab(value);
    if (newTab) this.selected = newTab;
  }

  sortTabs(tab1, tab2) {
    return Utils.compare(tab1.index, tab2.index);
  }
}
